<template>
  <section class="document-details">
    <h2 class="document-details__title" v-html="getTitleBlock(page, 'details', 'title')"></h2>
    <p class="document-details__intro" v-html="getTitleBlock(page, 'details', 'description')"></p>
    <Accordion v-if="sections.length" @toggleAccordion="isOpen = $event">
      <template v-slot:title>
        <span class="document-details__toggle">{{ isOpen ? 'Згорнути' : 'Читати повністю' }}</span>
      </template>
      <div class="document-details__body">
        <template v-for="section in sections">
          <h3 :key="'title-' + section.position" class="document-details__subtitle" v-html="section.content.title"></h3>
          <p
            v-if="section.content.description"
            :key="'text-' + section.position"
            v-html="section.content.description"
          ></p>
          <div
            v-if="tableRows(section.position).length"
            :key="'table-' + section.position"
            class="document-details__table-wrapper"
          >
            <table class="document-details__table">
              <thead>
                <tr>
                  <th v-html="tableRows(section.position)[0].key"></th>
                  <th v-html="tableRows(section.position)[0].value"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in tableRows(section.position).slice(1)" :key="index">
                  <td v-html="row.key"></td>
                  <td v-html="row.value"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </div>
    </Accordion>
  </section>
</template>

<script>
import { textBlock } from '@/entities/text-block';
import { Accordion } from '@/shared/ui/accordion';

export default {
  props: {
    page: {
      type: String,
      required: true,
    },
  },
  mixins: [ textBlock ],
  components: { Accordion },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    sections() {
      return this.getTextBlocks(this.page, 'details-sections');
    },
  },
  methods: {
    tableRows(position) {
      return this.getListBlock(this.page, `details-table-${position}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.document-details {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;

  ::v-deep .accordion {
    margin-bottom: 0;
    border-radius: 28px;
    background: #FFFFFF;
    box-shadow: inset 0 0 0 1px #E3EAF8;
  }

  ::v-deep .accordion__header,
  ::v-deep .accordion__body {
    background: transparent;
  }

  &__title {
    margin: 0 0 24px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 500;
    font-size: clamp(32px, 4vw, 52px);
    line-height: 1.1;
    color: #373A3D;
  }

  &__intro {
    margin: 0 0 24px;
    font-size: 18px;
    line-height: 29px;
    color: #4E5358;
  }

  &__toggle {
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 600;
    font-size: 19px;
    line-height: 26px;
    color: #4555CC;
  }

  &__body {
    padding-bottom: 24px;
    font-size: 16px;
    line-height: 26px;
    color: #4E5358;

    p {
      margin: 0 0 16px;
    }
  }

  &__subtitle {
    margin: 24px 0 12px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 600;
    font-size: 18px;
    line-height: 25px;
    color: #373A3D;

    &:first-child {
      margin-top: 0;
    }
  }

  &__table-wrapper {
    overflow-x: auto;
    border-radius: 16px;
    box-shadow: inset 0 0 0 1px #E3EAF8;
  }

  &__table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    line-height: 21px;

    th {
      padding: 12px 16px;
      background: #EBF2FF;
      text-align: left;
      font-weight: 600;
      color: #373A3D;
    }

    td {
      padding: 12px 16px;
      border-top: 1px solid #E3EAF8;
      vertical-align: middle;

      &:first-child {
        font-weight: 600;
        color: #373A3D;
      }
    }
  }
}
</style>
